import { useEffect } from 'react';
import ModalList from '../../../models/modal-list';

const useModalManager = () => {
  const renderedModalList = new ModalList();

  const mainInstance = () => {
    useEffect(() => {
      const ESCHandler = (e) => {
        const numOfModal = renderedModalList.getNumberOfModal();
        if (e.keyCode === 27) {
          if (numOfModal > 0) {
            renderedModalList.triggerCallback(numOfModal - 1);
            //  NOTE: remember that this is an async event listener,
            //  so if there's any state variables in the callback fn,
            // they will prolly be at their initial state
          }
        }
      };
      document.addEventListener('keydown', ESCHandler);
      return () => {
        document.removeEventListener('keydown', ESCHandler);
      };
    }, []);
  };

  const modalInstance = () => {
    const registerModal = (callback) => {
      const id = Math.random();
      renderedModalList.addModal({ callback, id });
      return id;
    };

    const unregisterModal = (id) => {
      renderedModalList.removeModal({ id });
    };

    return [registerModal, unregisterModal];
  };

  const [registerModal, unregisterModal] = modalInstance();
  mainInstance();
  return [registerModal, unregisterModal];
};

export default useModalManager;
